import * as React from 'react'
import cn from 'classnames'
import BookADemoButton from '../../ui/BookADemoButton'
import '../SovereignIntelligence/styles.css'
import { ReactComponent as GrowIcon } from '../../../assets/imgs/skillbridge/grow-icon.svg'
import { ReactComponent as TargetIcon } from '../../../assets/imgs/skillbridge/target-icon.svg'
import { ReactComponent as ResumeIcon } from '../../../assets/imgs/skillbridge/resume.svg'
import { ReactComponent as ShieldIcon } from '../../../assets/imgs/skillbridge/shield.svg'
import { ReactComponent as JobIcon } from '../../../assets/imgs/skillbridge/job.svg'
import ServiceToSuccessImage from '../../../assets/imgs/skillbridge/skillbridge-from-service-to-success.png'
import ProfileViewImage from '../../../assets/imgs/skillbridge/skillbridge-profile-view.png'
import PostManagementImage from '../../../assets/imgs/skillbridge/skillbridge-post-management.png'
import LeftGlowImage from '../../../assets/imgs/LeftGlow.png'
import './styles.css'

const OVERVIEW_CARDS = [
  {
    icon: TargetIcon,
    title: 'The SkillBridge Challenge',
    description:
      'Large enterprises struggle to bridge the gap between military experience and corporate roles. Talent Acquisition (TA) teams waste hundreds of hours manually decoding military codes, assessing eligibility windows, and mapping fragmented skills to open requisitions.',
  },
  {
    icon: GrowIcon,
    title: 'The Pod Solution',
    description:
      'Pod automates the entire DoW SkillBridge lifecycle. We provide an intuitive, high-conversion discovery platform that instantly translates military backgrounds into enterprise readiness. Fortune 500 trailblazers use Pod to seamlessly source, match, and onboard elite military talent at scale.',
  },
]

const FEATURE_ROWS = [
  {
    id: '01',
    title: '1. Seamless Branded Integration',
    emphasis: 'Own the Experience.',
    description:
      'Integrate a fully white-labeled, frictionless portal directly into your existing corporate careers ecosystem.',
    image: ServiceToSuccessImage,
  },
  {
    id: '02',
    title: '2. Intelligent Veteran Discovery',
    emphasis: 'Translate Aspirations to Roles.',
    description:
      'Veterans bypass confusing job boards. Pod dynamically maps military experience and future goals to your specific fellowship tracks in real time.',
    image: ProfileViewImage,
    reverse: true,
  },
  {
    id: '03',
    title: '3. Eliminate TA Friction',
    emphasis: 'No more manual vetting.',
    description:
      'Pod automatically verifies DoW SkillBridge eligibility windows, ensuring your recruiters only review compliant, qualified candidates.',
    image: PostManagementImage,
  },
]

const VALUE_CARDS = [
  {
    icon: ShieldIcon,
    title: 'Reduced Compliance Risk',
    description:
      'Automated verification safeguards your DoW SkillBridge partnership.',
  },
  {
    icon: ResumeIcon,
    title: 'Zero Guesswork',
    description:
      'AI-driven skill mapping eliminates the military-to-civilian translation barrier.',
  },
  {
    icon: JobIcon,
    title: 'Accelerated Time-to-Hire',
    description:
      'Transition military fellows into full-time corporate leaders before they even separate.',
  },
]

const SkillBridgeSection = () => {
  return (
    <div className='skillbridge-page'>
      <section className='skillbridge-hero'>
        <div className='skillbridge-hero-glow skillbridge-hero-glow--left' />
        <div className='skillbridge-hero-glow skillbridge-hero-glow--right' />
        <div className='box skillbridge-hero__content'>
          <div className='skillbridge-hero__copy'>
            <p className='skillbridge-eyebrow'>SkillBridge</p>
            <p className='skillbridge-subtitle'>a DoW initiative</p>
            <p className='skillbridge-hero__title'>
              With Pod, Veterans Transition into Top Tier Talent
            </p>
            <BookADemoButton className='skillbridge-hero__cta' />
          </div>
          <div className='skillbridge-overview-grid'>
            {OVERVIEW_CARDS.map((card, index) => {
              const Icon = card.icon

              return (
                <article
                  key={card.title}
                  className='sovereign-option-card skillbridge-overview-card'
                >
                  <div className='sovereign-option-head'>
                    <div className='skillbridge-overview-card__icon-wrap'>
                      <Icon className='sovereign-option-icon skillbridge-overview-card__icon' />
                    </div>
                  </div>
                  <h2 className='skillbridge-overview-card__title'>{card.title}</h2>
                  <p className='skillbridge-overview-card__description'>
                    {card.description}
                  </p>
                </article>
              )
            })}
          </div>
        </div>
      </section>

      <section className='skillbridge-features'>
        <div className='box'>
          {FEATURE_ROWS.map((feature) => (
            <article
              key={feature.title}
              className={cn('skillbridge-feature-row', {
                'skillbridge-feature-row--reverse': feature.reverse,
              })}
            >
              <img
                src={LeftGlowImage}
                alt=''
                aria-hidden='true'
                className={cn('skillbridge-feature-row__glow', {
                  'skillbridge-feature-row__glow--right': feature.reverse,
                })}
              />
              <div className='skillbridge-feature-row__copy'>
                <div className='skillbridge-feature-row__title'>
                  {feature.title}
                </div>
                <p>
                  <strong>{feature.emphasis}</strong> {feature.description}
                </p>
              </div>
              <div className='skillbridge-feature-row__visual'>
                <div className='skillbridge-feature-row__frame'>
                  <img src={feature.image} alt={feature.title} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className='skillbridge-value'>
        <div className='box'>
          <h2 className='skillbridge-value__title'>
            The Enterprise Value Proposition
          </h2>
          <div className='skillbridge-value__grid'>
            {VALUE_CARDS.map((card, index) => {
              const Icon = card.icon

              return (
                <article
                  key={card.title}
                  className='sovereign-option-card skillbridge-value-card'
                >
                  <div className='sovereign-option-head'>
                    <Icon className='sovereign-option-icon skillbridge-value-card__icon' />
                  </div>
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </article>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  )
}

export default SkillBridgeSection
